angular.module('leanlaw').controller('MatterOverviewCtrl', ['$scope', '$stateParams', function ($scope, $stateParams) {
  $scope.vm = {
    matterId: $stateParams.matterId,
    clientId: $stateParams.id,
    module: $scope.module
  };
}]);